module.exports = __webpack_public_path__ + "img/hoslogo4.8ae561fa.png";